import { render, staticRenderFns } from "./currentNews.vue?vue&type=template&id=0722080c&scoped=true&"
import script from "./currentNews.vue?vue&type=script&lang=ts&"
export * from "./currentNews.vue?vue&type=script&lang=ts&"
import style0 from "./currentNews.vue?vue&type=style&index=0&id=0722080c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0722080c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Users\\its_bas_sp_schramwy\\serviceportal\\RUB.Serviceportal\\ClientApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('0722080c', component.options)
    } else {
      api.reload('0722080c', component.options)
    }
    module.hot.accept("./currentNews.vue?vue&type=template&id=0722080c&scoped=true&", function () {
      api.rerender('0722080c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/currentNews.vue"
export default component.exports